// extracted by mini-css-extract-plugin
module.exports = {"main-component":"metricUp_main-component__12Pbh"};